import Carousel from 'Assets/js/library/carousel'
import CountdownTimer from 'Assets/js/library/countdown-timer'
import { Debounce, Throttle } from 'Assets/js/library/helpers'
import FocusTrap from 'Assets/js/library/focus-trap'
import {
  FormatMoney,
  FormatMoneyAmount,
} from 'Assets/js/library/template-helpers'
import SmoothScroll from 'Assets/js/library/smoothscroll'
import ExecuteGraphQlQuery from 'Assets/js/library/graphql'
import {
  AddItemToCart,
  FetchCart,
  UpdateCart,
  UpdateItemInCart,
} from 'Assets/js/library/cart'

window.SAXX.Library = {
  AddItemToCart,
  Carousel,
  CountdownTimer,
  Debounce,
  ExecuteGraphQlQuery,
  FetchCart,
  FocusTrap,
  FormatMoney,
  FormatMoneyAmount,
  SmoothScroll,
  Throttle,
  UpdateCart,
  UpdateItemInCart,
}
